import { CardInfo } from './LangingPageCard/LandingPageCard';

const workstations: CardInfo[] = [
  {
    articleNumber: '920002 1500',
    png: '/assets/landing-page/920002_1500.png',
    webp: '/assets/landing-page/920002_1500.webp',
    nameLocalisation: 'NAME_MLEVEL',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: '920012 1500',
    png: '/assets/landing-page/920012_1500.png',
    webp: '/assets/landing-page/920012_1500.webp',
    nameLocalisation: 'NAME_ELEVEL',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: '920022 1500',
    png: '/assets/landing-page/920022_1500.png',
    webp: '/assets/landing-page/920022_1500.webp',
    nameLocalisation: 'NAME_ELEVEL_PLUS',
    actionText: '',
    actionText2: '',
  },
];

const templates: CardInfo[] = [
  {
    articleNumber: 'template-0',
    png: '/assets/landing-page/template0.png',
    webp: '/assets/landing-page/template0.webp',
    nameLocalisation: '',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: 'template-1',
    png: '/assets/landing-page/template1.png',
    webp: '/assets/landing-page/template1.webp',
    nameLocalisation: '',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: 'template-2',
    png: '/assets/landing-page/template2.png',
    webp: '/assets/landing-page/template2.webp',
    nameLocalisation: '',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: 'template-3',
    png: '/assets/landing-page/template3.png',
    webp: '/assets/landing-page/template3.webp',
    nameLocalisation: '',
    actionText: '',
    actionText2: '',
  },
];

const others: CardInfo[] = [
  {
    articleNumber: '920801 1500',
    png: '/assets/landing-page/920801_1500.png',
    webp: '/assets/landing-page/920801_1500.webp',
    nameLocalisation: 'NAME_WORKBENCH',
    actionText: '',
    actionText2: '',
  },
  {
    articleNumber: '930505 800/6',
    png: '/assets/landing-page/930505_800_6.png',
    webp: '/assets/landing-page/930505_800_6.webp',
    nameLocalisation: 'NAME_TOOL_CABINET',
    actionText: '',
    actionText2: '',
  },
];

export const cardsData = {
  workstations,
  templates,
  others,
};
